(function () {
  'use strict';
  function initBannerPositioning() {
    var grid = document.querySelector('[js-project-grid]');
    if (!grid) return;

    var bannerCards = Array.from(grid.querySelectorAll('[js-banner-card]'));
    if (bannerCards.length === 0) return;

    function getBreakpoint() {
      var w = window.innerWidth;
      if (w < 750) return 'mobile';
      if (w < 990) return 'tablet';
      return 'desktop';
    }

    function getViewMode() {
      var container = document.querySelector('.Project_mainloop_new');
      if (!container) return 'list';
      return container.classList.contains('Project_mainloop_grid_new') ? 'grid' : 'list';
    }

    function getPositionAttr(breakpoint, viewMode) {
      if (breakpoint === 'mobile') {
        return viewMode === 'grid'
          ? 'data-mobile_grid_view_position'
          : 'data-mobile_list_view_position';
      }
      return viewMode === 'grid'
        ? 'data-desktop_grid_view_position'
        : 'data-desktop_list_view_position';
    }

    function repositionBanners() {
      var breakpoint = getBreakpoint();
      var viewMode = getViewMode();
      var attr = getPositionAttr(breakpoint, viewMode);

      bannerCards.forEach(function (card) {
        card.remove();
      });

      var sortedBanners = bannerCards
        .map(function (card) {
          return {
            el: card,
            pos: parseInt(card.getAttribute(attr), 10) || 9999
          };
        })
        .sort(function (a, b) {
          return a.pos - b.pos;
        });

      sortedBanners.forEach(function (banner) {
        var visibleChildren = Array.from(grid.children).filter(function (child) {
          return !child.classList.contains('Project_filtered_hidden_new');
        });
        var targetIndex = banner.pos - 1;

        if (targetIndex >= visibleChildren.length) {
          grid.appendChild(banner.el);
        } else {
          grid.insertBefore(banner.el, visibleChildren[targetIndex]);
        }
      });
    }

    repositionBanners();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(repositionBanners, 250);
    });

    var container = document.querySelector('.Project_mainloop_new');
    if (container) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'class') {
            repositionBanners();
            break;
          }
        }
      });
      observer.observe(container, { attributes: true, attributeFilter: ['class'] });
    }

    window._repositionBanners = repositionBanners;
  }

  function initFiltering() {
    var grid = document.querySelector('[js-project-grid]');
    if (!grid) return;

    var checkboxes = document.querySelectorAll('input[data-filter-category][data-filter-value]');
    var pillsContainer = document.querySelector('[js-applied-filter-pills]');

    if (checkboxes.length === 0) return;

    var closeSvg = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5002 4.19995L4.2002 10.5" stroke="#333333" stroke-width="1.5" stroke-linecap="square"/><path d="M4.2002 4.19995L10.5002 10.5" stroke="#333333" stroke-width="1.5" stroke-linecap="square"/></svg>';

    function getActiveFilters() {
      var filters = {};
      checkboxes.forEach(function (cb) {
        if (cb.checked) {
          var category = cb.getAttribute('data-filter-category');
          var value = cb.getAttribute('data-filter-value');
          if (!filters[category]) filters[category] = [];
          filters[category].push(value);
        }
      });
      return filters;
    }

    function applyFilters() {
      var activeFilters = getActiveFilters();
      var categories = Object.keys(activeFilters);
      var projectCards = grid.querySelectorAll('[js-project-card]');

      projectCards.forEach(function (card) {
        if (categories.length === 0) {
          card.classList.remove('Project_filtered_hidden_new');
          return;
        }

        var matches = categories.some(function (category) {
          var cardAttr = card.getAttribute('data-' + category) || '';
          var cardValues = cardAttr.split(',').map(function (v) { return v.trim(); }).filter(Boolean);
          var filterValues = activeFilters[category];
          return filterValues.some(function (fv) {
            return cardValues.indexOf(fv) !== -1;
          });
        });

        card.classList.toggle('Project_filtered_hidden_new', !matches);
      });

      if (typeof window._repositionBanners === 'function') {
        window._repositionBanners();
      }
    }

    function updateAppliedPills() {
      if (!pillsContainer) return;

      pillsContainer.innerHTML = '';

      var hasActive = false;

      checkboxes.forEach(function (cb) {
        if (!cb.checked) return;
        hasActive = true;

        var category = cb.getAttribute('data-filter-category');
        var value = cb.getAttribute('data-filter-value');
        var label = cb.parentElement.querySelector('span');
        var labelText = label ? label.textContent : value;

        var slide = document.createElement('div');
        slide.className = 'swiper-slide Project_innerpart_innerside_innerclear_innerloops_list_main_new';

        var pill = document.createElement('div');
        pill.className = 'Project_innerpart_innerside_innerclear_innerloops_list_new active';
        pill.innerHTML = '<span>' + labelText + '</span>' + closeSvg;

        pill.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          cb.checked = false;
          updateAppliedPills();
          applyFilters();
        });

        slide.appendChild(pill);
        pillsContainer.appendChild(slide);
      });

      if (hasActive) {
        var clearSlide = document.createElement('div');
        clearSlide.className = 'swiper-slide Project_innerpart_innerside_innerclear_innerloops_list_main_new';

        var clearBtn = document.createElement('div');
        clearBtn.className = 'Button_link_new';
        clearBtn.innerHTML = '<span>Clear Filters</span>';

        clearBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          checkboxes.forEach(function (cb) {
            cb.checked = false;
          });
          updateAppliedPills();
          applyFilters();
        });

        clearSlide.appendChild(clearBtn);
        pillsContainer.appendChild(clearSlide);
      }

      var filterSlider = document.querySelector('.Page_project_template_filter_slider');
      if (filterSlider && filterSlider.swiper) {
        filterSlider.swiper.update();
      }
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        updateAppliedPills();
        applyFilters();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBannerPositioning();
    initFiltering();
  });
})();
